import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { OldMethods } from './components/OldMethods';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoFor } from './components/WhoFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-green selection:text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <OldMethods data-id="element-4" />
      <Mechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Pricing data-id="element-12" />
      <Footer data-id="element-13" />
      <noscript data-id="element-14">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=912696691856874&ev=PageView&noscript=1" alt="" data-id="element-15" />
      </noscript>
    </div>;
}